<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar>
      <template slot="links">
        <sidebar-item
          :link="{ name: 'Availity', path: '/pages/availity' }"
        ></sidebar-item>
        <sidebar-item
          :link="{ name: 'EMS', path: '/pages/ems' }"
        ></sidebar-item>
        <sidebar-item
          :link="{ name: 'Insync', path: '/pages/insync' }"
        ></sidebar-item>
        <sidebar-item
          :link="{ name: 'Insurance Providers', path: '/pages/insurance-providers' }"
        ></sidebar-item>
        <sidebar-item
          :link="{ name: 'Directors', path: '/pages/directors' }"
        ></sidebar-item>
        <sidebar-item
          :link="{ name: 'Users', path: '/pages/users' }"
        ></sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel" ref="mainPanel">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar"> </dashboard-content>
    </div>
  </div>
</template>
<script>
import TopNavbar from "./TopNavbar.vue";
import DashboardContent from "./Content.vue";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { useLoginStore } from "src/stores/loginStore";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default {
  components: {
    TopNavbar,
    DashboardContent,
  },
  computed: {
    isAdmin() {
      return useLoginStore().isAdmin;
    },
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("main-panel");

        docClasses.add("perfect-scrollbar-on");
      } else {
        docClasses.add("perfect-scrollbar-off");
      }
    },
    scrollToTop() {
      this.$refs.mainPanel.scrollTop = 0;
    },
  },
  watch: {
    $route() {
      this.scrollToTop();
    },
  },
  mounted() {
    this.initScrollbar();
  },
};
</script>
<style scoped>
.wrapper {
  background: #ffffff;
  min-height: 100vh;
}

.main-panel {
  background: #ffffff;
  color: #000000;
}
</style>
